export const countSelected = (value: unknown): number =>
    Array.isArray(value) ? value.length : 0;

export const isIdSelected = (value: unknown, id: number): boolean => {
    if (!value) {
        return false;
    }

    if (Array.isArray(value)) {
        return value.some(selected => selected === String(id) || selected === id);
    }

    if (typeof value === 'string') {
        return value === String(id);
    }

    if (typeof value === 'number') {
        return value === id;
    }

    return false;
};
